import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dasherize'
})
export class DasherizePipe implements PipeTransform {
    transform(value: string | undefined | null): string {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value !== 'string') {
            return String(value);
        }

        return value
            .replace(/([A-Z])/g, (match, p1, offset) => {
                return (offset > 0 ? '-' : '') + p1.toLowerCase();
            })
            .toLowerCase();
    }
}
